import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MuiCheckbox from "./MuiCheckbox";
import { addItemToCart } from "api/Cart";
import { fetchViewedProducts } from "api/Viewed_product";
import RightQualityControl from "providers/QualityControlComponent/RightQualityControl";

interface Product {
    id: string;
    slug: string;
    name: string;
    img: string;
    seller: string;
    maxQty: number;
    checked: boolean;
    qty: number;
    price: number;
    oldPrice?: number;
    discount?: string | number;
}

export default function WishlistList() {
    const [products, setProducts] = useState<Product[]>([]);

    useEffect(() => {
        const loadViewedProducts = async () => {
            const res = await fetchViewedProducts('created_at,desc', 50);
            if (!res?.status || !res.data?.items) {
                setProducts([]);
                return;
            }

            const mapped: Product[] = res.data.items.map((item) => {
                const product = item.product;
                const originalPrice = Number(product.price) || 0;
                const apiDiscountPrice = Number(product.discount_price) || 0;
                const promotionPercent = Number(product.promotion?.percent) || 0;

                const computedDiscountPrice = apiDiscountPrice > 0
                    ? apiDiscountPrice
                    : (promotionPercent > 0 ? Math.round(originalPrice * (1 - promotionPercent / 100)) : originalPrice);

                const finalDiscountPrice = computedDiscountPrice > 0 && computedDiscountPrice < originalPrice
                    ? computedDiscountPrice
                    : originalPrice;

                const finalDiscountPercent = originalPrice > 0 && finalDiscountPrice < originalPrice
                    ? Math.round((1 - finalDiscountPrice / originalPrice) * 100)
                    : 0;

                return {
                    id: String(product.id),
                    slug: product.slug || "#",
                    name: product.name,
                    img: product.avatar,
                    seller: product.product_category?.name || "Dược Tâm Hạnh",
                    maxQty: 100,
                    checked: false,
                    qty: 0,
                    price: finalDiscountPrice,
                    oldPrice: finalDiscountPercent > 0 ? originalPrice : undefined,
                    discount: finalDiscountPercent > 0 ? `-${finalDiscountPercent}%` : undefined,
                };
            });

            setProducts(mapped);
        };

        loadViewedProducts();
    }, []);

    const totalChecked = products.filter(p => p.checked).length;
    const allChecked = totalChecked === products.length && products.length > 0;
    const indeterminate = totalChecked > 0 && totalChecked < products.length;

    const toggleCheckItem = (id: string) => {
        setProducts(prev =>
            prev.map(p =>
                p.id === id ? { ...p, checked: !p.checked } : p
            )
        );
    };

    const toggleCheckAll = () => {
        const target = !(allChecked && !indeterminate);
        setProducts(prev => prev.map(p => ({ ...p, checked: target })));
    };

    const deleteSelected = () => {
        setProducts(prev => prev.filter(p => !p.checked));
    };

    const changeQty = (id: string, value: number) => {
        setProducts((prev) =>
            prev.map((p) =>
                p.id === id
                    ? { ...p, qty: Math.max(0, Math.min(value, p.maxQty)) }
                    : p
            )
        );
    };

    return (
        <div className="MuiGrid-root MuiGrid-container MuiGrid-direction-xs-column">
            <header className="MuiPaper-root MuiAppBar-root MuiAppBar-positionFixed MuiAppBar-colorPrimary styles_appBar__Kzodx mui-fixed MuiPaper-elevation4 w-full-1199-24px show-1199">
                <div className="MuiToolbar-root MuiToolbar-regular styles_toolBar__DQTee MuiToolbar-gutters">
                    <Link to="/" className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnHamburger__POqzB" aria-label="back pagehome">
                        <span className="MuiButton-label">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                </span>
                                <img src="https://cdn-web-mobile-next.thuocsi.vn/images/header-v2/arrow-left.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                        </span>
                        <span className="MuiTouchRipple-root"></span>
                    </Link>
                    <p className="MuiTypography-root styles_formTitle__o8AZx MuiTypography-body1">Danh sách sản phẩm đã xem gần đây</p>
                </div>
            </header>
            <div className="styles_searchWrapper__1VsnB show-1199">
                <div className="MuiInputBase-root MuiInput-root styles_root_input__fUHE5 MuiInputBase-adornedStart">
                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1a5basm" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SearchIcon">
                        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                    </svg>
                    <input placeholder="Nhập tên thuốc, hoạt chất cần tìm" type="search" className="MuiInputBase-input MuiInput-input styles_input__p8e0Z MuiInputBase-inputAdornedStart MuiInputBase-inputTypeSearch MuiInput-inputTypeSearch" value="" />
                </div>
            </div>
            <div className="style_wrapperContent__9ddkL">

                {/* ==== TOP BAR ==== */}
                <div className="style_containerTop__j5JB3">
                    <span className="style_titleContent__NuXwE">
                        Danh sách sản phẩm đã xem gần đây
                    </span>

                    {/* <div className="style_rightContent__ql1ZG">
                        <div
                            className="style_wrapperCheckbox__sBg1i style_check__aDusd"
                            onClick={toggleCheckAll}
                        >
                            <span>Ẩn sản phẩm hết hàng</span>
                            <MuiCheckbox
                                checked={allChecked}
                                indeterminate={indeterminate}
                                onChange={toggleCheckAll}
                            />
                        </div>
                    </div> */}
                </div>

                {/* ==== PRODUCT LIST ==== */}
                {products.map((p) => (
                    <div key={p.id} className="style_wrapperCard__yyX_D">

                        <div className="styles_cardContainer__roWvH style_cardItem__rKGSb !pr-0">
                            <div className="styles_flex__YOT7Y">

                                {/* image */}
                                <a href="#">
                                    <div className="styles_wrapperImage__vkqUl">
                                        <img src={p.img} alt={p.name} />
                                    </div>
                                </a>

                                {/* info */}
                                <div className="styles_wrapperInfoProduct__zIAXY">
                                    <span className="styles_name__JFs3F">{p.name}</span>
                                    <div className="styles_sellerContainer__zCB_8">
                                        <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                            <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                                <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2713%27%20height=%2713%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                            </span>
                                            <img src="https://cdn-web-next.thuocsi.vn/icons/seller_store.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                                        </span>
                                        <a className="styles_cardNameStore__T1gCP" target="_blank" href="/flagship-store/merck-healthcare">Merck Healthcare</a>
                                    </div>
                                    <div className="styles_cardBadges__umsyP MuiBox-root css-0">
                                        <a className="styles_mobile_rootBase__8z7PQ" target="_blank" href="/deals">
                                            <img alt="tag-/deals" src="https://gcs.buymed.com/thuocsi-live/internal/cms/2024e1a6ffa3d0111cad282d9eeed6f3Tag_Label_-_Icon+Text-5.svg" title="Khuyến Mãi" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="styles_wrapperContent__K5zzD">
                                {/* <div className="styles_wrapperDiscount__H_zPT">
                                    <p className="MuiTypography-root styles_promo__Q5YiA MuiTypography-body1"> -1%</p>
                                    <a className="styles_cardDiscount__HubGJ" href="/product/medx-concor-5.0mg-merck-h30v">
                                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 text-[15px] line-through text-[#333333]" style={{ height: "25px" }}>{p.oldPrice}đ</div>
                                        </div>
                                    </a>
                                </div> */}
                                <div>
                                    <a className="" href="/product/medx-concor-5.0mg-merck-h30v">
                                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 text-[22px] text-[#428c04]" style={{ height: "34px" }}>{(p.price.toLocaleString('vi-VN', { maximumFractionDigits: 0 }))}đ</div>
                                        </div>
                                    </a>
                                </div>
                            </div>

                            {/* ==== quantity control ==== */}
                            <div className="styles_wrapperQuantityControl__LHcc9">
                                <span className="styles_cardNoted__fnyQc">
                                    Đặt tối đa {p.maxQty} sản phẩm
                                </span>

                                <RightQualityControl productId={Number(p.id)} productName={p.name} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
